import { Controller } from "@hotwired/stimulus";

const DEFAULT_CELL_SIZE = 80;

/**
 * Makes a table card draggable for the floor plan
 * Works with floor-plan controller's drop zone
 */
export default class extends Controller {
  connect() {
    this.element.addEventListener("dragstart", this.handleDragStart.bind(this));
    this.element.addEventListener("dragend", this.handleDragEnd.bind(this));
    this.dragGhost = null;
  }

  disconnect() {
    this.element.removeEventListener("dragstart", this.handleDragStart);
    this.element.removeEventListener("dragend", this.handleDragEnd);
    this.removeDragGhost();
  }

  get tableElement() {
    // The controller might be on the handle or the table itself
    return this.element.closest("[data-table-id]") || this.element;
  }

  get isOnFloorPlan() {
    return !!this.tableElement.closest("[data-floor-plan-target='grid']");
  }

  get cellSize() {
    const grid = document.querySelector("[data-floor-plan-target='grid']");
    if (grid && grid.dataset.cellSize) {
      return parseFloat(grid.dataset.cellSize);
    }
    return DEFAULT_CELL_SIZE;
  }

  handleDragStart(event) {
    const tableId = this.element.dataset.tableId;
    event.dataTransfer.setData("text/plain", tableId);
    event.dataTransfer.effectAllowed = "move";
    this.tableElement.classList.add("opacity-50");
    this.hideAllHoverCards();

    // Create custom drag ghost for unplaced tables
    if (!this.isOnFloorPlan) {
      this.createDragGhost(event);
    }
  }

  createDragGhost(event) {
    const table = this.tableElement;
    const gridWidth = parseInt(table.dataset.gridWidth) || 1;
    const gridHeight = parseInt(table.dataset.gridHeight) || 1;
    const cellSize = this.cellSize;

    const width = gridWidth * cellSize - 8;
    const height = gridHeight * cellSize - 8;

    this.dragGhost = document.createElement("div");
    this.dragGhost.style.cssText = `
      width: ${width}px;
      height: ${height}px;
      position: fixed;
      top: -1000px;
      left: -1000px;
      pointer-events: none;
    `;

    // Copy classes from original table to retain shape and status colors
    this.dragGhost.className = table.className + " shadow-lg";

    // Copy content from original
    const content = table.querySelector(".text-center");
    if (content) {
      this.dragGhost.innerHTML = content.outerHTML;
    }

    document.body.appendChild(this.dragGhost);
    event.dataTransfer.setDragImage(this.dragGhost, 8, 8);
  }

  removeDragGhost() {
    if (this.dragGhost) {
      this.dragGhost.remove();
      this.dragGhost = null;
    }
  }

  hideAllHoverCards() {
    document
      .querySelectorAll("[data-table-hover-target='card']")
      .forEach((card) => card.classList.add("hidden"));
  }

  handleDragEnd(event) {
    this.tableElement.classList.remove("opacity-50");
    this.removeDragGhost();
  }
}
